<template>
  <div class="app-layout">
    <TopBar />
    <div class="app-layout__content">
      <main class="app-main app-main--expanded">
        <div class="app-main__container">
          <slot></slot>
        </div>
      </main>
    </div>
    <footer class="app-footer">
      <div class="app-footer__content">
        <div class="app-footer__links">
          <router-link to="/privacy-policy">{{ $t('legal.privacyPolicy') }}</router-link>
          <span class="separator">|</span>
          <router-link to="/cookie-policy">{{ $t('legal.cookiePolicy') }}</router-link>
          <span class="separator">|</span>
          <router-link to="/terms-of-service">{{ $t('legal.termsOfService') }}</router-link>
        </div>
        <div class="app-footer__copyright">
          © {{ currentYear }} Bati Vision 360. {{ $t('legal.footer.allRightsReserved') }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
/// <reference types="vue" />
import { computed } from 'vue';
// @ts-ignore
import TopBar from '../TopBar.vue'

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
/* Main content area using design system */
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-layout__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: calc(70px + var(--trial-banner-offset, 0px));
}

.app-main {
  flex: 1;
  width: 100%;
  padding: var(--space-6) var(--space-8);
  overflow-y: auto;
  background-color: #f5f5f5;
}

.app-main--expanded {
  width: 100%;
}

.app-main__container {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* Responsive design */
@media (max-width: 1024px) {
  .app-main {
    padding: var(--space-4) var(--space-6);
  }
}

@media (max-width: 768px) {

  .app-layout__content {
    flex-direction: column;
  }
  
  .app-main {
    padding: var(--space-2) var(--space-2); /* Reduce padding significantly */
    width: 100%;
  }

  .app-main__container {
    max-width: 100%;
    padding: 0; /* Remove all padding from container */
  }
}

@media (max-width: 480px) {
  .app-main {
    padding: var(--space-1) var(--space-1); /* Even less padding */
  }

  .app-main__container {
    padding: 0;
  }
}

/* Footer styles */
.app-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: var(--space-4) var(--space-6);
  text-align: center;
  flex-shrink: 0;
}

.app-footer__content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.app-footer__links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--space-2);
}

.app-footer__links a {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.app-footer__links a:hover {
  color: #0d6efd;
  text-decoration: underline;
}

.app-footer__links .separator {
  color: #dee2e6;
}

.app-footer__copyright {
  color: #adb5bd;
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .app-footer {
    padding: var(--space-3) var(--space-4);
  }
  
  .app-footer__links {
    flex-wrap: wrap;
  }
}
</style>
